import React from 'react'

const FillInGapsQuestion = ({ question, answer, onAnswerChange }) => {
  const handleAnswerChange = (blankIndex, value) => {
    const currentAnswers = answer || {}
    const newAnswers = {
      ...currentAnswers,
      [blankIndex]: value
    }
    onAnswerChange(newAnswers)
  }

  // Handle different formats: blanks array, questionText with markers, or simple question text
  const blanks = question.blanks || []
  const questionText = question.questionText || question.question || question.gapsText || ''
  
  // Check if questionText has blank markers
  const hasBlankMarkers = questionText.includes('_____') || questionText.includes('[blank]')
  
  const renderQuestionWithBlanks = () => {
    if (hasBlankMarkers) {
      // Format: "Question _____ text _____"
      return questionText.split(/(_____|\[blank\])/).map((part, index) => {
        if (part === '_____' || part === '[blank]') {
          const blankIndex = Math.floor(index / 2)
          const blank = blanks[blankIndex]
          return (
            <input
              key={index}
              type="text"
              value={answer?.[blankIndex] || ''}
              onChange={(e) => handleAnswerChange(blankIndex, e.target.value)}
              placeholder={blank?.placeholder || 'Enter answer'}
              className="inline-block mx-2 px-2 py-1 border-b-2 border-indigo-500 bg-transparent focus:outline-none focus:border-indigo-700 min-w-[100px]"
            />
          )
        }
        return <span key={index}>{part}</span>
      })
    } else if (blanks.length > 0) {
      // Format: Array of blanks - display numbered inputs
      return (
        <div className="space-y-4">
          <p className="text-gray-900 text-lg leading-relaxed">{questionText || question.question}</p>
          <div className="space-y-3">
            {blanks.map((blank, index) => (
              <div key={index} className="flex items-center space-x-3">
                <label className="font-medium text-gray-700 min-w-[80px]">Blank {index + 1}:</label>
                <input
                  type="text"
                  value={answer?.[index] || ''}
                  onChange={(e) => handleAnswerChange(index, e.target.value)}
                  placeholder={blank?.placeholder || 'Enter answer'}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                />
              </div>
            ))}
          </div>
        </div>
      )
    }
    
    // Fallback: just show the question text
    return <p className="text-gray-900 text-lg leading-relaxed">{questionText}</p>
  }

  return (
    <div className="space-y-4">
      {/* Question Text */}
      {question.question && !hasBlankMarkers && (
        <div className="bg-white p-4 rounded-lg border border-gray-200">
          <p className="text-lg text-gray-900 leading-relaxed">{question.question}</p>
        </div>
      )}
      
      {(() => {
        const content = renderQuestionWithBlanks()
        // If content is already a div with space-y-4 (from blanks array format), don't wrap again
        if (content && content.type === 'div' && content.props?.className?.includes('space-y-4')) {
          return (
            <div className={`${hasBlankMarkers ? 'bg-gray-50' : ''} p-4 rounded-lg`}>
              {content}
            </div>
          )
        }
        // Otherwise wrap in the normal div
        return (
          <div className={`${hasBlankMarkers ? 'bg-gray-50' : ''} p-4 rounded-lg`}>
            <div className="text-gray-900 text-lg leading-relaxed">
              {content}
            </div>
          </div>
        )
      })()}
      
      <div className="text-sm text-gray-600">
        <p><strong>Marks:</strong> {question.marks}</p>
        <p><strong>Instructions:</strong> Fill in the blanks with the most appropriate answers.</p>
      </div>
    </div>
  )
}

export default FillInGapsQuestion
